import { type ReactNode } from 'react'
import { ChevronLeftIcon } from '@heroicons/react/24/outline'

export default function WarehouseActionModal({
  title,
  titleAccessory,
  children,
  submitLabel,
  submitDisabled,
  showSubmit = true,
  wide = false,
  titleDivider = false,
  closeLabel = 'Cancel',
  onClose,
  onBack,
  onSubmit,
}: {
  title: string
  titleAccessory?: ReactNode
  children: ReactNode
  submitLabel: string
  submitDisabled?: boolean
  showSubmit?: boolean
  wide?: boolean
  titleDivider?: boolean
  closeLabel?: string
  onClose: () => void
  onBack?: () => void
  onSubmit: () => void
}) {
  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4"
      onClick={onClose}
    >
      <div
        className={`relative w-full rounded-xl bg-white p-5 shadow-xl ${
          wide ? 'max-w-2xl' : 'max-w-lg'
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className={`flex items-start gap-2 ${
            titleDivider ? '-mx-5 border-b border-gray-200 px-5 pb-4' : ''
          }`}
        >
          {onBack ? (
            <button
              type="button"
              className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded border border-gray-200 text-gray-700 hover:bg-gray-50"
              aria-label="Back"
              onClick={onBack}
            >
              <ChevronLeftIcon className="h-4 w-4" />
            </button>
          ) : null}
          <div className="flex min-w-0 flex-1 items-center justify-between gap-3">
            <h3 className="min-w-0 text-base font-semibold text-gray-900">{title}</h3>
            {titleAccessory ? <div className="shrink-0">{titleAccessory}</div> : null}
          </div>
        </div>
        <div className="mt-4 space-y-3">{children}</div>
        <div className="mt-5 flex justify-end gap-2">
          <button type="button" className="btn btn-secondary text-sm" onClick={onClose}>
            {closeLabel}
          </button>
          {showSubmit ? (
            <button
              type="button"
              className="btn btn-primary text-sm"
              disabled={submitDisabled}
              onClick={onSubmit}
            >
              {submitLabel}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  )
}
